<template>
	<section class="coach-page">
		<loader :dialog="loading"></loader>
		<floating-alert :message="alertMessage" :show="alertShow" :type="alertType"></floating-alert>

		<!-- ─── En-tête ─── -->
		<div class="page-header">
			<div class="page-header-left">
				<div class="page-icon-box">
					<v-icon size="22" color="white">mdi-whistle</v-icon>
				</div>
				<div>
					<h1 class="page-title">Coachs</h1>
					<p class="page-sub">
						<span class="team-count">{{ coaches.length }}</span>
						membre{{ coaches.length > 1 ? 's' : '' }} dans l'équipe
					</p>
				</div>
			</div>

			<div class="page-header-right">
				<v-text-field
					v-model="search"
					prepend-inner-icon="mdi-magnify"
					placeholder="Rechercher un coach..."
					outlined
					dense
					hide-details
					class="header-search"
					color="blue darken-2"
				></v-text-field>

			</div>
		</div>

		<!-- ─── États vide / chargement ─── -->
		<card-loading v-if="loading"></card-loading>
		<not-found v-else-if="filteredCoaches.length === 0"></not-found>

		<!-- ─── Grille de cartes ─── -->
		<v-row v-else class="cards-grid mt-2">
			<v-col
				v-for="c in filteredCoaches"
				:key="c._id"
				cols="12" sm="6" md="4" lg="3"
			>
				<div class="coach-card">

					<!-- Bannière -->
					<div class="card-banner">
						<div class="banner-deco d1"></div>
						<div class="banner-deco d2"></div>
						<div class="banner-deco d3"></div>
					</div>

					<!-- Avatar chevauchant -->
					<div class="avatar-wrap">
						<v-avatar size="80" class="coach-avatar">
							<img v-if="c.photo" :src="c.photo" :alt="c.fullName" />
							<span v-else class="avatar-initials">{{ initials(c.fullName) }}</span>
						</v-avatar>
					</div>

					<!-- Corps -->
					<div class="card-body">
						<p class="coach-name">{{ c.fullName }}</p>
						<span class="role-badge">Coach sportif</span>

						<!-- Évaluation -->
						<div class="rating-row">
							<v-rating
								readonly
								:value="c.generalNote || 0"
								color="#f59e0b"
								background-color="#d1d5db"
								dense
								half-increments
								size="16"
							></v-rating>
							<span class="rating-val">{{ (c.generalNote || 0).toFixed(1) }}</span>
						</div>
					</div>

					<!-- Pied de carte -->
					<div class="card-footer">
						<div v-if="c.phone" class="contact-item">
							<v-icon size="14" color="#9ca3af">mdi-phone</v-icon>
							<span class="contact-text">{{ c.phone }}</span>
						</div>
						<div v-if="c.email" class="contact-item">
							<v-icon size="14" color="#9ca3af">mdi-email</v-icon>
							<span class="contact-text">{{ c.email }}</span>
						</div>
						<div v-if="!c.phone && !c.email" class="contact-empty">
							<v-icon size="14" color="#d1d5db">mdi-information-outline</v-icon>
							<span class="contact-text">Aucun contact renseigné</span>
						</div>
					</div>

				</div>
			</v-col>
		</v-row>
	</section>
</template>

<script>
import service from "@/services";
import Loader from "@/components/Loader.vue";
import NotFound from "@/components/Notfound.vue";
import CardLoading from "@/components/CardLoading.vue";
import FloatingAlert from "@/components/FloatingAlert.vue";
export default {
	components: { Loader, NotFound, CardLoading, FloatingAlert },
	data() {
		return {
			loading: false,
			search: "",
			coaches: [],
			alertMessage: "",
			alertShow: null,
			alertType: "",
		};
	},
	computed: {
		filteredCoaches() {
			if (!this.search) return this.coaches;
			return this.coaches.filter((c) => c.fullName.toLowerCase().includes(this.search.toLowerCase()));
		},
	},
	created() { this.initialize(); },
	methods: {
		initials(name) {
			if (!name) return "?";
			const parts = name.trim().split(" ");
			return parts.length >= 2
				? (parts[0][0] + parts[1][0]).toUpperCase()
				: name.slice(0, 2).toUpperCase();
		},
		manageAlert(display, type, message) { this.alertShow = display; this.alertType = type; this.alertMessage = message; },
		initialize() {
			this.loading = true;
			service.getSpecificUsers("COACH")
				.then((r) => { this.coaches = r.data?.users || r.data || []; this.loading = false; })
				.catch((e) => { console.log(e); this.loading = false; });
		},
	},
};
</script>

<style scoped>
.coach-page { font-family: Montserrat, sans-serif; padding: 8px 0 32px; }

/* ─── En-tête ─── */
.page-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 28px;
	gap: 16px;
	flex-wrap: wrap;
}
.page-header-left { display: flex; align-items: center; gap: 16px; flex: 1; min-width: 200px; }
.page-icon-box {
	width: 52px;
	height: 52px;
	border-radius: 14px;
	background: #c62828;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.page-title { font-size: 1.6rem; font-weight: 800; color: #111827; margin: 0 0 3px; letter-spacing: -0.3px; }
.page-sub { font-size: 0.75rem; color: #9ca3af; margin: 0; font-weight: 500; }
.team-count { font-weight: 700; color: #374151; }

.page-header-right { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.header-search { max-width: 240px; }

.add-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
	white-space: nowrap;
}

/* ─── Carte coach ─── */
.coach-card {
	background: #ffffff;
	border-radius: 20px;
	overflow: hidden;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	position: relative;
}
.coach-card:hover {
	transform: translateY(-5px);
	box-shadow: 0 14px 36px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04);
}

/* Bannière */
.card-banner {
	height: 88px;
	background: #1a1a2e;
	position: relative;
	overflow: hidden;
}
.banner-deco {
	position: absolute;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.06);
}
.d1 { width: 110px; height: 110px; top: -35px; right: -25px; }
.d2 { width: 70px;  height: 70px;  top: 25px;  left: -15px; }
.d3 { width: 44px;  height: 44px;  bottom: -10px; right: 50px; }

/* Avatar */
.avatar-wrap {
	display: flex;
	justify-content: center;
	margin-top: -40px;
	position: relative;
	z-index: 1;
}
.coach-avatar {
	border: 4px solid #ffffff !important;
	background: #1565c0 !important;
	box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18) !important;
}
.avatar-initials {
	color: #ffffff;
	font-size: 1.3rem;
	font-weight: 800;
	font-family: Montserrat, sans-serif;
	letter-spacing: 1px;
}

/* Corps */
.card-body {
	text-align: center;
	padding: 12px 20px 16px;
}
.coach-name {
	font-size: 1rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 8px;
	line-height: 1.3;
}
.role-badge {
	display: inline-block;
	font-size: 0.68rem;
	font-weight: 700;
	color: #1565c0;
	background: #eff6ff;
	padding: 3px 12px;
	border-radius: 50px;
	letter-spacing: 0.3px;
	margin-bottom: 14px;
	text-transform: uppercase;
}
.rating-row {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
}
.rating-val {
	font-size: 0.8rem;
	font-weight: 700;
	color: #f59e0b;
}

/* Pied de carte */
.card-footer {
	border-top: 1px solid #f3f4f6;
	padding: 12px 18px;
	display: flex;
	flex-direction: column;
	gap: 6px;
}
.contact-item, .contact-empty {
	display: flex;
	align-items: center;
	gap: 7px;
}
.contact-text {
	font-size: 0.72rem;
	color: #9ca3af;
	font-weight: 500;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* ─── Dialog ─── */
.dialog-header { display: flex; align-items: center; gap: 14px; padding: 18px 20px 14px; }
.dialog-icon { width: 34px; height: 34px; border-radius: 8px; background: #c62828; display: flex; align-items: center; justify-content: center; }
.dialog-title { font-size: 0.88rem; font-weight: 700; color: #111827; margin: 0 0 2px; }
.dialog-sub { font-size: 0.68rem; color: #9ca3af; margin: 0; }
.save-btn { background: #1565c0 !important; color: white !important; font-family: Montserrat, sans-serif; font-weight: 700; font-size: 0.82rem; }
</style>
